<template>
  <div class="row">
    <v-snackbar
      class="mt-5"
      :color='color'
      :timeout="3000"
      :top="true"
      v-model="alert"
    >{{message}}</v-snackbar>
    <v-container fluid class="bannerElement mb-auto" id="check">
      <v-layout row class="justify-center custom_fullScreen">
        <v-flex xs5 class="container-white border-all-1 corner-all-10">
          <div class="container mb-auto">
            <!-- <div>
              <router-link class="link text-primary-apiculus" to="/">
                <v-icon class="text-primary-apiculus">keyboard_arrow_left</v-icon>
                <span class="icon_set">Back</span>
              </router-link>
            </div>
            <router-link class="link" to="/">
              <img :src='navLogo' width="40%" class="img-fluid mt10 mb20">
            </router-link> -->
            <div>
              <a class="link text-primary-apiculus" href="/">
                <v-icon class="text-primary-apiculus">keyboard_arrow_left</v-icon>
                <span class="icon_set">Back</span>
              </a>
            </div>
            <a class="link" href="/">
              <img :src='navLogo' width="40%" class="img-fluid mt10 mb20">
            </a>
            <h3 class="py-3">Signup for {{profileDetails.name}}</h3>
            <form id="cloud-signup" class="" @submit.prevent="initiateRegistration()">
              <v-text-field
                label="First Name*"
                v-model.trim="form.fname"
                data-vv-name="First Name"
                v-validate="'required|alpha_spaces'"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('First Name')">
              </v-text-field>
              <!-- <span class="text-danger form_danger is-danger" v-if="errors.has('firstName')">{{ errors.first('firstName') }}
              </span> -->
              <v-text-field
                label="Last Name*"
                v-model.trim="form.lname"
                data-vv-name="Last Name"
                v-validate="'required|alpha_spaces'"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('Last Name')">
              </v-text-field>

              <v-text-field
                label="Company Name*"
                v-model.trim="form.organization_name"
                data-vv-name="Company Name"
                data-vv-as="Company Name"
                v-validate="'required'"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('Company Name')"
              ></v-text-field>

              <v-text-field
                label="E-mail*"
                v-model.trim="form.email"
                data-vv-name="email"
                v-validate="'required|email'"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('email')">
              </v-text-field>

              <v-layout>
                <v-flex xs5>
                  <v-autocomplete
                    :items= 'getCountryNameWithCode'
                    item-value= 'name'
                    item-text= 'name'
                    v-model.trim="form.countryCode"
                    label="Country Code*"
                    data-vv-name="Country Code"
                    v-validate="'required'"
                    data-vv-validate-on="blur|input|change|update"
                    :error-messages="errors.collect('Country Code')">
                  </v-autocomplete>
                </v-flex>
                <v-flex xs7 class="ml-2">
                  <div >
                    <v-text-field
                      label="Phone Number*"
                      v-model.trim="form.mobileNumber"
                      data-vv-name="Phone Number"
                      v-validate='{required: true, regex:mobileRegex}'
                      data-vv-validate-on="blur|input|change|update"
                      :error-messages="errors.collect('Phone Number')">
                    </v-text-field>
                  </div>
                </v-flex>
              </v-layout>

              <!-- <div v-else >
                <v-text-field
                  label="Mobile Number"
                  v-model.trim="form.mobileNumber"
                  data-vv-name="Mobile Number"
                  v-validate="'numeric|min:6|max:15'"
                  :error-messages="errors.collect('Mobile Number')"
                >
                </v-text-field>
              </div> -->

              <v-autocomplete
                :items= 'countryNames'
                item-text='name'
                item-value='code'
                v-model.trim="form.country"
                label="Country*"
                data-vv-name="Country"
                v-validate="'required'"
                @change="getCountryDetails(form.country),emptyState()"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('Country')">
              </v-autocomplete>
              <v-autocomplete
                v-model="form.state" data-vv-name="State/Province"
                :items='stateList'
                item-text='Subdivision_Name'
                item-value='Subdivision_Name'
                v-validate="'required'"
                :error-messages="errors.collect('State/Province')"
                label="State/Province*">
              </v-autocomplete>

              <v-select
                :items= 'currencies'
                label="Currency*"
                v-model.trim="form.currency"
                data-vv-name="Currency"
                v-validate="'required'"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('Currency')">
              </v-select>

              <v-select
                :items= 'ApiculusEnv.regions'
                item-text='displaytext'
                item-value='name'
                label="Preferred Region*"
                v-model="form.acsRegion"
                data-vv-name="Region"
                v-validate="'required'"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('Region')">
              </v-select>

              <v-select
                v-if="this.showTaxProfileSelection"
                :items= 'TaxationType'
                label="Taxation Type*"
                v-model.trim="form.tax_category"
                data-vv-name="Tax category"
                item-text='displayText'
                item-value='value'
                v-validate="'required'"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('Tax category')">
              </v-select>
              <v-text-field
                v-else
                disabled
                label="Taxation Type"
                v-model.trim="form.tax_category"
                data-vv-name="Tax category"
                v-validate="'required'"
                data-vv-validate-on="blur|input|change|update"
                :error-messages="errors.collect('Tax category')">
              </v-text-field>

              <p class="help_note text-grey75" v-if="!form.tax_category">Please choose the correct organisation type for determining your organisation’s taxability.</p>

              <v-text-field
                v-if="showResellerCodeField"
                label="Reseller Code"
                v-model.trim="form.resellerCode"
              >
              </v-text-field>

              <!-- <div class="disFlex">
                <v-checkbox
                  class="mt-0 pt-0 flex-grow-0"
                  v-model="eulaAgreememt"
                  type="checkbox"
                  value="true"
                  v-validate="'required'"
                  label=''
                  data-vv-name='Master Services Agreement'
                  required
                ></v-checkbox>

                <span v-if="!showEULA && !showPrivacyPolicy" class="checkbox_align">The above information is correct.</span>
                <span v-else class="checkbox_align">I have read and agree to the
                  <a v-if="showEULA" class='linkColor' @click="routeToStaticPage(setEULA)">Master Services Agreement</a>
                  <span v-if="showEULA && showPrivacyPolicy"> and </span>
                  <a v-if="showPrivacyPolicy" class='linkColor' @click="routeToStaticPage(setPrivacyPolicy)">Privacy Policy</a>.
                </span>
              </div> -->
              <vue-recaptcha
                id="recaptcha"
                ref="recaptcha"
                @verify="onCaptchaVerified"
                @expired="onCaptchaExpired"
                :sitekey="siteKey"
                size="invisible">
              </vue-recaptcha>

              <v-btn :disabled="!isFormValid" type="submit" class="rounded-0 marginauto auth_form m0 mt10">submit
              </v-btn>
            </form>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import accountServices from '../services/signup'
import VueRecaptcha from 'vue-recaptcha'
import { mapGetters } from 'vuex'
export default {
  name: 'signup',
  components: { VueRecaptcha },
  computed: {
    ...mapGetters({
      getCountryName: 'getCountryName',
      getCountryNameWithCode: 'getCountryNameWithCode',
      getCountryState: 'getCountryState',
      profileDetails: 'getprofileDetails'
    }),
    siteKey () {
      return JSON.parse(localStorage.getItem('ApiculusEnv')).siteKey
    },
    /* eslint-disable */
    // tax_type1 () {
    //   if (this.$store.state.ApiculusEnv.hasOwnProperty('taxationType') && this.$store.state.ApiculusEnv.taxationType.length >= 1) {
    //     this.tax_type1Detail = this.$store.state.ApiculusEnv.taxationType[0].name
    //     this.tax_type1Validation = this.$store.state.ApiculusEnv.taxationType[0].validation
    //     return this.$store.state.ApiculusEnv.taxationType.length >= 1
    //   } else {
    //     return false
    //   }
    // },
    // tax_type2 () {
    //   if (this.$store.state.ApiculusEnv.hasOwnProperty('taxationType') && this.$store.state.ApiculusEnv.taxationType.length >= 2) {
    //     this.tax_type2Detail = this.$store.state.ApiculusEnv.taxationType[1].name
    //     this.tax_type2Validation = this.$store.state.ApiculusEnv.taxationType[1].validation
    //     return this.$store.state.ApiculusEnv.taxationType.length >= 1
    //   } else {
    //     return false
    //   }
    // },
    // tax_type3 () {
    //   if (this.$store.state.ApiculusEnv.hasOwnProperty('taxationType') && this.$store.state.ApiculusEnv.taxationType.length >= 3) {
    //     this.tax_type3Detail = this.$store.state.ApiculusEnv.taxationType[2].name
    //     this.tax_type3Validation = this.$store.state.ApiculusEnv.taxationType[2].validation
    //     return this.$store.state.ApiculusEnv.taxationType.length >= 1
    //   } else {
    //     return false
    //   }
    // },
    showResellerCodeField () {
      return Object.keys(this.$store.state.ApiculusEnv).length && this.$store.state.ApiculusEnv.resellerEnabled
    },
    isFormValid () {
      let isValid = true
      if (this.fields.hasOwnProperty('First Name')) {
        let keys = Object.keys(this.fields)
        for (let i = 0; i < keys.length; i++) {
          if (!(this.fields[keys[i]] && this.fields[keys[i]].valid)) {
            isValid = false
            break
          }
        }
        return isValid
      } else {
        return false
      }
    },
    countryNames () {
      if (this.getCountryName && this.getCountryName.length) {
        // return this.getCountryName.map(item => item.name)
        return this.getCountryName
      } else {
        return []
      }
    },
    // showEULA () {
    //   return this.ApiculusEnv && this.ApiculusEnv.hasOwnProperty('eulaRequired') && this.ApiculusEnv.eulaRequired
    // }
    showTaxProfileSelection () {
      return (this.ApiculusEnv.usersTaxProfile && this.ApiculusEnv.usersTaxProfile.userInput) || false
    },
    defaultTaxProfile () {
      return (this.ApiculusEnv.usersTaxProfile && this.ApiculusEnv.usersTaxProfile.defaultProfile) || 'Taxable'
    }
  },
  /* eslint-disable */
  data: () => ({
    ApiculusEnv: JSON.parse(localStorage.getItem('ApiculusEnv')),
    tax_type1Detail:'',
    tax_type2Detail:'',
    tax_type3Detail:'',
    form: {
      'fname': '',
      'lname': '',
      'organization_name': '',
      'email': '',
      'countryCode': '',
      'mobileNumber': '',
      'country': '',
      'state': '',
      'currency': '',
      'acsRegion': '',
      'tax_category': '',
      'tax_type1':'',
      'tax_type2':'',
      'tax_type3':'',
      'taxation_id1':'',
      'taxation_id2':'',
      'taxation_id3':'',
      'billingtype': 'postpaid',
      'resellerCode': '',
      'g-recaptcha-response': null
    },
    stateList: [],
    eulaAgreememt: null,
    showEULA: false,
    setEULA: '',
    eulaData: '',
    showPrivacyPolicy: false,
    setPrivacyPolicy: '',
    privacyData: '',
    currencies: [],
    // countryNames: [],
    message: '',
    navLogo: '',
    alert: false,
    color: '',
    mobileRequired: Boolean,
    cloud: '',
    getStateCode: [],
    TaxationType: [{
        'displayText': 'Indian Organisation or Individual (Non-SEZ)',
        'value': 'Taxable'
      },{
        'displayText': 'Indian Organisation or Individual (Located in a SEZ)', 
        'value': 'SEZ'
      },{
        'displayText': 'Non-Indian Organisation or Individual (Located Outside India)', 
        'value': 'EMBASSY'
      }
    ],
    mobileRegex:''
  }),
  methods: {
    emptyState() {
      this.form.state = ''
    },
    register (form) {
      this.form['tax_type1'] = this.tax_type1Detail
      this.form['tax_type2'] = this.tax_type2Detail
      this.form['tax_type3'] = this.tax_type3Detail
      this.$validator.validateAll().then((res) => {
        if (res) {
          // form.country && (this.form.country = this.form.country.name)
          form.countryCode && (this.form.countryCode = this.form.countryCode.split('+')[1])
          this.$store.dispatch('ACTION_INIT_ACCOUNT', { ...form }).then(res => {
            if (!res.success) {
              if (res.error.hasOwnProperty('message')) {
                this.message = res.error.message
                this.alert = true
                this.color = 'error'
              }
              this.form['g-recaptcha-response'] = ''
              this.$refs.recaptcha.reset()
            } else {
              if (JSON.parse(localStorage.getItem('ApiculusEnv')).adminApprovalRequired) {
                this.$store.state.forEmailVerification = false
                this.$store.state.forAdminApproval = true
              } else {
                this.$store.state.forEmailVerification = true
                this.$store.state.forAdminApproval = false
              }
              this.$router.push('/success')
            }
          })
        }
      })
    },
    initiateRegistration () {
      this.$refs.recaptcha.execute()
    },
    onCaptchaVerified (res) {
      if (res && res.length) {
        this.form['g-recaptcha-response'] = res
        this.register(this.form)
      } else {
        this.color = 'error'
        this.message = 'Error in verifying the reCAPTCHA'
        this.alert = true
      }
    },
    onCaptchaExpired (res) {
      this.form['g-recaptcha-response'] = ''
      this.$refs.recaptcha.reset()
    },
    getCountryDetails (countryCode) {
      let finalCountryCode = this.countryNames.find(res=> res.code == countryCode)
      if (finalCountryCode) {
        accountServices.getStatesByCountryCode(finalCountryCode.objectId).then(res => {
          if (res.length > 0) {
            this.stateList = res
          } else {
            this.stateList = [{'Subdivision_Name': finalCountryCode.name}] 
          } 
        })
      }
    },
    routeToStaticPage (page) {
      if (page === 'eula') {
        let newWindow = window.open('', '_blank', 'width=1000,height=800')
        newWindow.document.write(this.eulaData)
        let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Master Services Agreement')
        titleTag.appendChild(textNode)
        newWindow.document.getElementsByTagName('head')[0].appendChild(titleTag)
      }
      if (page === 'privacyPolicy') {
        let newWindow = window.open('', '_blank', 'width=1000,height=800')
        newWindow.document.write(this.privacyData)
        let titleTag = document.createElement('title')
        let textNode = document.createTextNode('Privacy Policy')
        titleTag.appendChild(textNode)
        newWindow.document.getElementsByTagName('head')[0].appendChild(titleTag)
      }
    }
    // openEULA () {
    //   this.$store.dispatch('ACTION_LIST_EULA')
    // },
  },
  mounted () {
    if (!this.showTaxProfileSelection && this.defaultTaxProfile) {
      this.$set(this.form, 'tax_category', this.defaultTaxProfile)
    }
  },
  created () {
    if(this.$store.state.ApiculusEnv.mobileRegex!=undefined){
    this.mobileRegex = new RegExp(this.$store.state.ApiculusEnv.mobileRegex);
    }
    else{
      this.mobileRegex = /^[0-9]{7,13}$/
    }
    this.$store.state.ApiculusEnv = JSON.parse(localStorage.getItem('ApiculusEnv'))
    if (this.$store.state.ApiculusEnv.hasOwnProperty('taxationType') && this.$store.state.ApiculusEnv.taxationType.length >= 1) {
      this.tax_type1Detail = this.$store.state.ApiculusEnv.taxationType[0].name
    }
    if (this.$store.state.ApiculusEnv.hasOwnProperty('taxationType') && this.$store.state.ApiculusEnv.taxationType.length >= 2) {
      this.tax_type2Detail = this.$store.state.ApiculusEnv.taxationType[1].name
    }
    if (this.$store.state.ApiculusEnv.hasOwnProperty('taxationType') && this.$store.state.ApiculusEnv.taxationType.length >= 3) {
      this.tax_type3Detail = this.$store.state.ApiculusEnv.taxationType[2].name
    }
    this.$store.dispatch('ACTION_GET_COUNTRY_NAME').then((res) => {
      this.getStateCode = res
      let defcountry = ''
      if (Array.isArray(this.$store.state.ApiculusEnv.country)) {
        defcountry = this.$store.state.ApiculusEnv.country[0]
      } else {
        defcountry = this.$store.state.ApiculusEnv.country
      }
      let defcountryCode = ''
      if (defcountry.length > 2) {
        defcountry = defcountry.slice(0, 1) + defcountry.slice(1).toLowerCase()
        defcountryCode = this.getCountryName.find(item => item.name === defcountry).code
      } else if (defcountry.length === 2) {
        defcountryCode = defcountry.toUpperCase()
      }
      this.$set(this.form, 'country', defcountryCode)
      this.getCountryDetails(this.form.country)
    })

    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'logo.png' }).then(res => {
      if (res) {
        let downloadFile = 'data:image/png;base64,' + res
        this.navLogo = downloadFile
      } else {
        this.navLogo = ''
      }
    })

    if (Array.isArray(this.$store.state.ApiculusEnv.currency)) {
      this.$store.state.ApiculusEnv.currency.forEach(res => {
        let currencyName = Object.keys(res)[0]
        if (res[currencyName].hasOwnProperty("active") && res[currencyName].active) {
          this.currencies.push(...Object.keys(res))
        }
      })
    } else {
      this.currencies.push(this.$store.state.ApiculusEnv.currency)
    }
    this.form.currency = this.currencies[0]
    // this.cloud = this.ApiculusEnv.labels.app_title

    this.$store.dispatch('ACTION_GET_STATIC_PAGE', { directory: 'documents', document_type: 'eula' }).then(res => {
      if (typeof res !== 'object' && res) {
        this.showEULA = true
        this.eulaData = atob(res)
        this.setEULA = 'eula'
      } else {
        this.showEULA = false
      }
    })

    this.$store.dispatch('ACTION_GET_STATIC_PAGE', { directory: 'documents', document_type: 'privacyPolicy' }).then(res => {
      if (typeof res !== 'object' && res) {
        this.showPrivacyPolicy = true
        this.privacyData = atob(res)
        this.setPrivacyPolicy = 'privacyPolicy'
      } else {
        this.showPrivacyPolicy = false
      }
    })

    this.$store.dispatch('ACTION_DOWNLOAD_LOGO', { directory: 'images', document_type: 'banner.png' }).then(res => {
      let downloadFiles
      if (res && typeof res === 'string') {
        downloadFiles = 'data:image/png;base64,' + res
        this.bannerAsset = downloadFiles
        this.bannerShow = true
        // this.ChangeBackgroungImageOfTab(this.bannerAsset)
        let urlString = ''
        setTimeout(() => {
          urlString = document.getElementById('check')
          urlString.classList.add('bannerElement')
          urlString.style.backgroundImage = 'url(' + this.bannerAsset + ')'
        }, 0)
      } else {
        this.bannerAsset = ''
        this.bannerShow = false
      }
    })
  }
}
</script>

<style>
.justify-center {
  justify-content: center;
}
.slight-left {
  position: relative;
  left: -6rem;
}
.icon_set {
  position: relative;
  bottom: 4px;
}
.mt0 {
  margin-top: 0;
}
.checkbox_align {
  vertical-align: super;
  color: #6c757d;
  font-size: 15.5px;
}
.linkColor {
  color: #379dcd!important;
}
</style>
